// extracted by mini-css-extract-plugin
export default {"wrapper":"Timer_wrapper__s+sVQ","timer":"Timer_timer__Och3Q"};